import { useModalStore } from '@/shared/lib';
import { EditApiTokenModal } from '../ui';
import type { ApiToken } from '@/entities/api-token';

type EditApiTokenModalParams = {
  apiToken: ApiToken;
  accountNumber: string;
  onBack: () => void;
};

export function useEditApiTokenModal() {
  const { showDialogComponent, closeDialog } = useModalStore();

  const openEditApiTokenModal = ({
    apiToken,
    accountNumber,
    onBack,
  }: EditApiTokenModalParams) => {
    showDialogComponent({
      component: (
        <EditApiTokenModal
          apiToken={apiToken}
          accountNumber={accountNumber}
          onBack={onBack}
        />
      ),
      className: 'sm:max-w-[48rem] max-h-[90vh] overflow-y-auto border-0 flex',
      onClose: closeDialog,
    });
  };

  return { openEditApiTokenModal };
}
